/* unplugin-vue-components disabled */import { render } from "./Delete.vue?vue&type=template&id=564e3ea0"
import script from "./Delete.vue?vue&type=script&lang=js"
export * from "./Delete.vue?vue&type=script&lang=js"

import "./Delete.vue?vue&type=style&index=0&id=564e3ea0&lang=scss"

import exportComponent from "D:\\Project\\Juanfu\\CBK定制版\\hcontrol_download\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__